import { warnIfOfflineNoCache } from '@school-manage/utils/offline';
import { createFileRoute } from '@tanstack/react-router';

import { NftDetailError } from './-components/error/NftDetailError';
import { NftDetail } from './-components/NftDetail';
import { NftDetailSkeleton } from './-components/pending/NftDetailSkeleton';
import { useNftDetail } from './-logic/useNftDetail';
import { NftDetailContext } from './-logic/useNftDetailContext';

export const Route = createFileRoute('/_authed/achievement/$achievementId')({
  beforeLoad: ({
    context: { queryClient },
    location,
    params: { achievementId },
  }) => {
    warnIfOfflineNoCache(location, [
      queryClient.getQueryData(['nft-details', { nftUuid: achievementId }]),
    ]);
  },
  component: NftDetailPage,
  errorComponent: NftDetailError,
  pendingComponent: NftDetailSkeleton,
});

function NftDetailPage() {
  return (
    <NftDetailContext.Provider value={useNftDetail()}>
      <NftDetail />
    </NftDetailContext.Provider>
  );
}
